module.exports = __webpack_public_path__ + "static/media/badge_0000.7dd735fc.png";